const bcbQRCodeStatus = require('../pix/bcb/qrcodeStatus');

const qrcodeStatus = {
  active: 0,
  done: 1,
  removedByReceiver: 2,
  removedByPSP: 3,
  convertToJDPI(status) {
    switch (status) {
      case bcbQRCodeStatus.ACTIVE:
        return this.active;
      case bcbQRCodeStatus.DONE:
        return this.done;
      case bcbQRCodeStatus.REMOVED_BY_RECEIVER:
        return this.removedByReceiver;
      case bcbQRCodeStatus.REMOVED_BY_PSP:
        return this.removedByPSP;
      default:
        throw new Error('Invalid QRCode status to convert to JDPI');
    }
  }
};

module.exports = qrcodeStatus;
